/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-webapp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.51
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleInteger
 */
export interface SimpleInteger {
    /**
     * 
     * @type {number}
     * @memberof SimpleInteger
     */
    value: number;
}

/**
 * Check if a given object implements the SimpleInteger interface.
 */
export function instanceOfSimpleInteger(value: object): value is SimpleInteger {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function SimpleIntegerFromJSON(json: any): SimpleInteger {
    return SimpleIntegerFromJSONTyped(json, false);
}

export function SimpleIntegerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleInteger {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function SimpleIntegerToJSON(value?: SimpleInteger | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

